import { FC, ReactNode } from "react";
import styled from "styled-components/native";
import { ImageBackground, ImageSourcePropType } from "react-native";


interface CheckMainBlockProps {
  bgColor?: string;
  bgImage?: ImageSourcePropType;
}

const CheckMainBlockWrapper = styled(ImageBackground)<CheckMainBlockProps>`
  padding: 20px;
  border-radius: 32px;
  background-color: ${(props) => props.bgColor || "#fff"};
  position: relative;
  overflow: hidden;
`;

const BackgroundImage = styled.Image`
  position: absolute;
  right: 0;
  bottom: 0;
  height: 100%;
`;

const CheckMainBlock: FC<CheckMainBlockProps & { children: ReactNode }> = ({
  bgColor,
  bgImage,
  children,
}) => {
  return (
    <CheckMainBlockWrapper
      bgColor={bgColor}
    >
      {bgImage && <BackgroundImage source={bgImage} />}
      {children}
    </CheckMainBlockWrapper>
  );
};

export default CheckMainBlock;